import { Person } from "@models/person.model";
import { BaseConverter } from "@converters/base.converter";
import { PersonDto } from "@dtos/person.dto";

export class PersonConverter extends BaseConverter <Person, PersonDto> {
    modelToDto(model: Person): PersonDto {
         let birthDate: string | undefined;

        if (model.birthDate instanceof Date) {
            birthDate = model.birthDate.toISOString();
        } else if (typeof model.birthDate === "string") {
            birthDate = model.birthDate;
        } else {
            birthDate = undefined;
        }
        
        return new PersonDto(
            model.identificationCode,
            model.name,
            model.surname,
            model.email,
            model.mobileNumber,
            model.bio,
            model.locale,
            model.fullAddress,
            birthDate,
            model.gender
            
        )
    }
    dtoToModel(dto: PersonDto): Person {
        return new Person(
            dto.identificationCode,
            dto.name,
            dto.surname,
            dto.email,
            dto.mobileNumber,
            dto.bio,
            dto.locale,
            dto.fullAddress,
            dto.birthDate ? new Date(dto.birthDate) : undefined,
            dto.gender
        )
    }



}